import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LightingUpAngularModule } from 'lighting-up-angular';
import { DossierPatientComponent } from './dossier-patient.component';

@NgModule({
	declarations: [DossierPatientComponent],
	imports: [CommonModule, LightingUpAngularModule],
	exports: [DossierPatientComponent]
})
export class DossierPatientModule { }
